import strikeZoneSector from "../StrikeZoneSector.js";

const strikeZoneSectors = {
    all: { key: "all",  name: "All zones", zones: Object.values(strikeZoneSector).map( sz => sz.key ) },
    outer: { key: "out",  name: "Out of zone", zones: Object.values(strikeZoneSector).filter( sz => !sz.isInZone).map( sz => sz.key ) },
    inner: { key: "in",  name: "In the zone", zones: Object.values(strikeZoneSector).filter( sz => sz.isInZone).map( sz => sz.key ) },
};

export default strikeZoneSectors;